<template>
  <main-layout>

    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-97"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <!--  TODO: i18n  -->
        <label slot="title">サイネージ</label>
        <!--  TODO: auth code  -->
        <!--  TODO: i18n  -->
        <narrow-down
          v-if="showFlg"
          @click="toCreateVisualPage"
          v-auth="{ auth: '060407' }"
          slot="cancel">
          サイネージページを追加
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">

      <!--   検索エリア開始   -->
      <div class="panel-search">
        <el-form :model="query" :rules="rules" class="search-form" ref="ruleForm" label-width="123px" label-position="left">

          <!-- ページ名 -->
          <div class="fm-row">
            <el-form-item size="small" prop="cmsTitle" label="ページ名">
              <el-input maxlength="30"
                v-model="query.cmsTitle"
                class="fm-input"
                :placeholder="'ページ名（部分一致）'"
              ></el-input>
            </el-form-item>
          </div>

          <!-- サブタイトル -->
          <div class="fm-row">
            <el-form-item size="small" prop="cmsSubTitle" label="サブタイトル">
              <el-input maxlength="30"
                v-model="query.cmsSubTitle"
                class="fm-input"
                :placeholder="'サブタイトル（部分一致）'"
              ></el-input>
            </el-form-item>
          </div>

          <!-- 表示形式 -->
          <div class="fm-row">
            <el-form-item size="small" label="表示形式">
              <el-checkbox-group v-model="query.diplayMethodList" @change="handleChange">
                <el-checkbox size="mini" label="00">
                  すべて
                </el-checkbox>
                <el-checkbox size="mini" label="01">
                  マップ
                </el-checkbox>
                <el-checkbox size="mini" label="02">
                  リスト（画像あり）
                </el-checkbox>
                <el-checkbox size="mini" label="03">
                  リスト（画像なし）
                </el-checkbox>
                <el-checkbox size="mini" label="04">
                  カレンダー
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>

          <!--  検索ボタン  -->
          <div class="btn-area fm-row">
            <narrow-down
              @click="handleClickSearch"
            >
              {{$t("button.common.narrow")}}
            </narrow-down>
            <cancel-narrow-down
              class="link-primary margin-left-8"
              @click="clearSearchParams"
            >
              {{$t('button.system.building.search.clear')}}
            </cancel-narrow-down>
          </div>
        </el-form>
      </div>

      <el-row class="margin-top-28" ref="searchResultTable">
        <div>
          <visual-page-management-search-result
            v-show="showSearchResult"
            :result="searchResult"
            :show-loading="showTableLoading"
            @up="sortUp"
            @down="sortDown"
            @on-paging="handlePaging"
            @on-detail="handleDetail"
            @on-delete="handleDelete"
          />
        </div>
      </el-row>

      <visual-page-management-type-select-popup
        :visible.sync="pageManagementSelectFlg"
      />

    </div>

  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import Menubar from "@/components/leftmenu/DashBoard"
import HeadTitle from "@/components/common/head/head";
import NarrowDown from "@/components/common/generalButton/NarrowDown";
import CancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import VisualPageManagementSearchResult from "@/views/cms/page/search/SearchPageManagementResult";
import PageSearchRuleFactory from "@/rules/rule-page-search"
import api from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg";
import VisualPageManagementTypeSelectPopup from "@/components/system/popup/VisualPageManagementTypeSelectPopup"

const QUERY_SAVE_KEY = "visual-env-page-management-search-query";

export default {
  name: "VisualPageSearch",
  components: {
    VisualPageManagementTypeSelectPopup,
    VisualPageManagementSearchResult,
    CancelNarrowDown, NarrowDown, Menubar, MainLayout, HeadTitle },
  data() {
    return {
      showFlg: false,
      pageManagementSelectFlg: false,
      ownerSearchFlg: false,
      buildingSearchFlg: false,
      floorSearchFlg: false,
      areaSearchFlg: false,
      query: {
        cmsTitle: null,
        cmsSubTitle: null,
        diplayMethodList: ["00"],
        pageSize: 10,
        pageNumber: 1
      },
      rules: PageSearchRuleFactory.searchRules(this),
      area: false,
      searchResult: {
        totalCount: 0,
        totalPage: 0,
        pageSize: 10,
        pageNumber: 1,
        body: []
      },
      showSearchResult: false,
      showTableLoading: false
    }
  },
  created() {
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "サイネージ",
      }
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    this.$authCheck("060406");
  },
  methods: {
    handleChange(){
      if (this.query.diplayMethodList.length > 0) {
        if (this.query.diplayMethodList[0] == "00" && this.query.diplayMethodList.length > 1) {
          this.query.diplayMethodList.shift()
        } else if (this.query.diplayMethodList[this.query.diplayMethodList.length - 1] == "00") {
          this.query.diplayMethodList = ["00"]
        }
      }
    },
    toCreateVisualPage() {
      this.pageManagementSelectFlg = true
    },

    handlePaging(paging) {
      this.query.pageNumber = paging.pageNumber;
      this.query.pageSize = paging.pageSize;
      this.doneSearch();
    },

    handleDetail(cmsId) {
      this.$router.push({ name: "page-management-create", query: { cmsId: cmsId } });
    },

    handleDelete(cmsId) {
      this.showTableLoadingAnim();
      api.deleteVisualPageManagement(cmsId)
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }

          this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
            field: "サイネージページ"
          }))

          this.doneSearch();
        })
        .catch(error => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.hideTableLoadingAnim();
        });
    },

    showTableLoadingAnim() {
      this.showTableLoading = true;
    },

    hideTableLoadingAnim() {
      this.showTableLoading = false;
    },

    handleClickSearch() {
      this.query.pageNumber = 1;
      this.query.pageSize = 10;
      this.doneSearch();
    },

    doneSearch() {
      this.$refs.ruleForm.validate((success) => {
        if (success) {
          this.showSearchResult = true;
          this.showTableLoadingAnim();

          this.$saveQueryParam(QUERY_SAVE_KEY, this.query);

          var req = { ...this.query }
          if (this.query.diplayMethodList.length > 0) {
            if (this.query.diplayMethodList[0] == "00") {
              req.diplayMethodList = []
            }
          }

          api.searchVisualPageManagement(req)
            .then(({ data }) => {
              const { body } = data;
              if (!statusErrorCodeMsg(data.statusCode, this)) {
                return;
              }
              this.searchResult = {
                totalCount: body.totalCount,
                totalPage: body.totalPage,
                pageSize: body.pageSize,
                pageNumber: body.pageNumber,
                body: body.body.flatMap(area => {
                  let pageList = [];
                  const basic = {
                    ownerId: area.ownerId,
                    ownerName: area.ownerName,
                    ownerExId: area.ownerExId,
                    buildingId: area.buildingId,
                    buildingName: area.buildingName,
                    buildingExId: area.buildingExId,
                    floorId: area.floorId,
                    floorName: area.floorName,
                    areaId: area.areaId,
                    areaName: area.areaName,
                    cmsId: area.cmsId,
                    cmsTitle: area.cmsTitle,
                    cmsSubTitle: area.cmsSubTitle,
                    diplayMethod: area.diplayMethod
                  };
                  pageList.push(basic);
                  return pageList;
                })
              };
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .finally(() => {
              this.hideTableLoadingAnim();
            });
        }
      });
    },

    // オーナー選択
    selectOwner() {
      this.ownerSearchFlg = true;
    },
    // ビル選択
    selectBuilding() {
      this.buildingSearchFlg = true;
    },
    // フロア選択
    selectFloor() {
      this.floorSearchFlg = true;
    },
    // エリア選択
    selectArea() {
      this.areaSearchFlg = true;
    },

    // オーナー選択-子组件
    getOwnerInfo: function (owner) {
      if (this.query.ownerId !== owner.id) {
        this.query.buildingId = null;
        this.query.buildingExId = null;
        this.query.buildingName = null;
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = owner.id;
      this.query.ownerName = owner.name;
      this.query.ownerExId = owner.exId;
    },
    // 获取 ビル選択 子画面的值
    getBuildingInfo(building) {
      if (this.query.buildingId !== building.buildingId) {
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = building.ownerId;
      this.query.ownerExId = building.ownerExId;
      this.query.ownerName = building.ownerName;
      this.query.buildingId = building.buildingId;
      this.query.buildingExId = building.buildingExId;
      this.query.buildingName = building.buildingName;
    },
    // 获取 フロア選択子画面的值
    getFloorInfo(floor) {
      if (this.query.floorId !== floor.floorId) {
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = floor.ownerId;
      this.query.ownerName = floor.ownerName;
      this.query.ownerExId = floor.ownerExId;
      this.query.buildingName = floor.buildingName;
      this.query.buildingExId = floor.buildingExId;
      this.query.buildingId = floor.buildingId;
      this.query.floorName = floor.floorName;
      this.query.floorId = floor.floorId;
    },
    // 获取 エリア選択子画面的值
    getAreaInfo(area) {
      this.query.ownerId = area.ownerId;
      this.query.ownerExId = area.ownerExId;
      this.query.ownerName = area.ownerName;
      this.query.buildingId = area.buildingId;
      this.query.buildingExId = area.buildingExId;
      this.query.buildingName = area.buildingName;
      this.query.floorId = area.floorId;
      this.query.floorName = area.floorName;
      this.query.areaId = area.areaId;
      this.query.areaName = area.areaName;
    },
    // クリア
    clearSearchParams() {
      this.$saveQueryParam(QUERY_SAVE_KEY, null)

      this.query.cmsTitle = null
      this.query.cmsSubTitle = null
      this.query.diplayMethodList = ["00"]
      // (this.query.pageSize = DEFAULT_PAGE_SIZE),
      // (this.query.pageNumber = DEFAULT_PAGE_NUMBER),
      this.query.totalCount = 0
      this.searchResult.totalPage = 0
      this.searchResult.totalCount = 0
      this.searchResult.body = []
      this.isShow = false
      this.showSearchResult = false;
      this.$refs["ruleForm"].resetFields();
    },
    sortUp(cmsId) {
      const index = this.searchResult.body.findIndex((page) => cmsId === page.cmsId);
      if (index > 0) {
        this.exchange(index, index - 1);
      }
    },
    sortDown(cmsId) {
      const index = this.searchResult.body.findIndex((page) => cmsId === page.cmsId);
      if (index >= 0 && index < this.searchResult.body.length - 1) {
        this.exchange(index, index + 1);
      }
    },
    exchange(index1, index2) {
      let page1 = this.searchResult.body[index1];
      let page2 = this.searchResult.body[index2];

      const allPageIds = this.searchResult.body.filter(page => page.areaId === page1.areaId).map(page => page.cmsId);

      let idArrayIndex1 = allPageIds.indexOf(page1.cmsId);
      let idArrayIndex2 = allPageIds.indexOf(page2.cmsId);

      allPageIds[idArrayIndex1] = page2.cmsId;
      allPageIds[idArrayIndex2] = page1.cmsId;

      this.showTableLoadingAnim();
      api.deviceEnvViewOrderUpdate(page1.areaId, allPageIds)
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.$set(this.searchResult.body, index1, page2);
          this.$set(this.searchResult.body, index2, page1);
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.hideTableLoadingAnim();
        });
    }
  },
  mounted() {

    if (this.$checkFuncCode("020100") || this.$checkFuncCode("060140")) {
      this.showFlg = true
    } else {
      this.showFlg = false
    }

    let query = this.$getQueryParam(QUERY_SAVE_KEY);
    if(query != null) {
      this.query = query;
      this.doneSearch();
    }
  }
}
</script>

<style scoped>

</style>
